import { useMemo } from 'react';

import { useQuery } from '@tanstack/react-query';

import { GetExtendedVoucherWarningsPayload, getExtendedVoucherWarnings } from '~/services/PromoService';

type Params = {
  voucherIds: Array<string>;
  brand: GetExtendedVoucherWarningsPayload['brand'];
  enabled: boolean;
};

const WARNING_TYPES: NonNullable<GetExtendedVoucherWarningsPayload['warningTypes']> = [
  'standard',
  'extended-voucher-user-expiry',
  'extended-pending-translations',
];

export function useGetExtendedVoucherWarnings({ voucherIds, brand, enabled }: Params) {
  const ids = useMemo(() => [...new Set(voucherIds.filter(Boolean))].sort(), [voucherIds]);

  return useQuery({
    queryKey: ['vouchers', 'extended-warnings', brand, ids],
    queryFn: ({ signal }) =>
      getExtendedVoucherWarnings({ brand, voucherIds: ids, warningTypes: WARNING_TYPES }, { signal }),
    enabled: enabled && ids.length > 0,
    refetchOnWindowFocus: false,
    select: (response) => new Map(response.result.vouchers.map((voucher) => [voucher.voucherId, voucher])),
  });
}
